import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberMasking'
})
export class NumberMaskingPipe implements PipeTransform {

  transform(value: string): string {
    // let maskingValue = `${value.substr(0, 2)}(xxx)-xxx-${value.substr(value.length - 4, value.length)}`;
    const maskingValue = `(xxx)-xxx-${value.substr(value.length - 4, value.length)}`;
    return maskingValue;
  }

}
